import { FC, useMemo } from 'react';
import { Typography, Checkbox } from 'antd';
import { deepCopy, isNotEmpty } from '@lhb/func';
import { leftIcon } from '@/views/recommend/pages/detail/ts-config';
import { businessStatus } from '../../ts-config';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

const { Text } = Typography;

/**
 * @Description 标题行
 */
const Title: FC<{
  mapIns,
  listRef,
  item,
  index,
  listData,
  setItemData,
  needFitView, // 市场容量下不需要为false，其他默认true
  cityProvinceInfo, // 左上角选中的省市数据
  isBatchCollect, // 是否是批量收藏状态
  batchCollectIds, // 批量收藏的开店区域ids
  setBatchCollectIds, // 设置批量收藏的开店区域ids
  /** 切换展开项 */
  changeExpand: Function,
}> = ({
  mapIns,
  listRef,
  item,
  index,
  listData,
  setItemData,
  needFitView = true, // 市场容量下不需要为false，其他默认true
  cityProvinceInfo, // 左上角选中的省市数据
  isBatchCollect, // 是否是批量收藏状态
  batchCollectIds, // 批量收藏的开店区域ids
  setBatchCollectIds, // 设置批量收藏的开店区域ids
  changeExpand,
}) => {

  cityProvinceInfo;

  const showRank = useMemo(() => {
    const { rank } = item;
    if (+rank) {
      return +rank + 1;
    }
    return '';
  }, [item]);

  const methods = useMethods({
    endExpandChange: () => {
      const isFrontEndExpanded = !item.isFrontEndExpanded;
      item.isFrontEndExpanded = isFrontEndExpanded;
      listRef?.current && listRef?.current?.resetAfterIndex(index);
      setItemData({
        visible: isFrontEndExpanded, // 是否显示详情
        id: isFrontEndExpanded ? item?.id : null,
        detail: isFrontEndExpanded ? item : null, // 存放详情相关字段
        isFirst: false
      });
      if (item.isFrontEndExpanded && needFitView) {
        const { lng, lat } = item;
        mapIns && +lng && +lat && mapIns.setZoomAndCenter(17, [+lng, +lat], false, 50);
      }
      // }
      // 将其余项收起
      const len = listData.length;
      for (let i = 0; i < len; i++) {
        if (i !== index && listData[i]?.isFrontEndExpanded) {
          listData[i].isFrontEndExpanded = false;
          listRef?.current?.resetAfterIndex(i);
        }
      }

      changeExpand?.(!!isFrontEndExpanded);
    },

    onChange: (e: any) => {
      const { id } = item;
      const isChecked = e.target.checked;
      if (isChecked) {
        if (batchCollectIds?.length >= 500) {
          V2Message.warning('最多勾选500个开店区域');
          return;
        }
        setBatchCollectIds((state) => [...state, id]);
        return;
      }
      const ids = deepCopy(batchCollectIds); // 这里一定要深拷贝，否则因为是引用类型的数据，会指向ids。就会直接修改掉ids
      const targetIdIndex = ids.indexOf(id);
      if (targetIdIndex !== -1) {
        ids.splice(targetIdIndex, 1);
        setBatchCollectIds(ids);
      }
    },
  });

  return (
    <div className={styles.titRow} onClick={methods.endExpandChange} >
      <div className={cs(
        styles.leftSection,
        isNotEmpty(item?.distance) ? styles.short : ''
      )}
      >
        <div className={styles.isFlex}>
          {/* 是否是批量收藏状态 */}
          {
            isBatchCollect ? <div onClick={(e) => e.stopPropagation()} className={item?.status === businessStatus.NEW ? 'mr-4' : ''} >
              <Checkbox checked={batchCollectIds.includes(item?.id)} onChange={methods.onChange} />
            </div> : <></>
          }
          <>
            {
              item?.rank < 3 ? <div className={styles.topImg}>
                <img
                  src={leftIcon[item.rank].url}
                  width='100%'
                  height='100%'
                />
              </div> : <div className={cs(
                'c-222 bold fs-14',
                showRank ? 'pr-2 pl-4' : '')
              }
              >
                {showRank}{showRank ? '.' : ''}
              </div>
            }
          </>
        </div>
        <Text ellipsis={ { tooltip: item?.name }} className={'c-222 bold fs-14 ml-5'} >
          {item?.name || '-'}
        </Text>
      </div>
      <div className={cs('ml-4', styles.rightSection)}>
        <IconFont
          iconHref='pc-common-icon-a-iconarrow_down'
          className={cs(item?.isFrontEndExpanded ? styles.arrowIconUp : styles.arrowIcon, 'c-959 fs-12')}
        />
      </div>
    </div>
  );
};

export default Title;
